export function sortOrderBefore<T extends { sortOrder: number }>(rowsWithoutDragged: T[], targetIndex: number) {
  const previous = rowsWithoutDragged[targetIndex - 1]
  const next = rowsWithoutDragged[targetIndex]
  if (previous && next) return (previous.sortOrder + next.sortOrder) / 2
  if (next) return next.sortOrder - 1000
  return (previous?.sortOrder ?? 0) + 1000
}
